import React from "react";
import { Box, Chip } from "@mui/material";
import { AssetFinanceUrl } from "../../../../config";
import DynamicTableForJson from "../../../../data/DynamicTable/dynamicTableForJson";
import InterestWaiverForm from "./form";

const base_url = AssetFinanceUrl.uri;

const formatCurrency = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return `KES ${Number(value).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
};

const STATUS_COLORS = {
  PENDING: "warning",
  APPROVED: "success",
  REJECTED: "error",
};

const rightsTourSteps = [
  {
    target: ".dynamic-table-header",
    content:
      "This is the Interest Waiver page, where you can request an interest waiver on a customer's loan for a checker to approve.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to search for a customer's loan and request a new interest waiver.",
    placement: "right",
  },
  {
    target: ".dynamic-table-actions",
    content: "Approve or reject a pending interest waiver from this dropdown.",
    placement: "left",
  },
];

const columns = [
  { field: "Id", headerName: "Waiver ID", width: 100 },
  { field: "CustomerName", headerName: "Customer", flex: 1 },
  { field: "CustomerPhone", headerName: "Phone", flex: 1 },
  { field: "LoanId", headerName: "Loan ID", width: 100 },
  { field: "ProductName", headerName: "Product", flex: 1 },
  {
    field: "RequestedAmount",
    headerName: "Waiver Amount",
    flex: 1,
    valueGetter: (params) => formatCurrency(params.row.RequestedAmount),
  },
  {
    field: "InterestBefore",
    headerName: "Interest Before",
    flex: 1,
    valueGetter: (params) => formatCurrency(params.row.InterestBefore),
  },
  { field: "Narration", headerName: "Narration", flex: 1 },
  { field: "Requester", headerName: "Requested By", flex: 1 },
  { field: "DateCreated", headerName: "Date Requested", flex: 1 },
  {
    field: "WaiverStatus",
    headerName: "Status",
    width: 130,
    renderCell: (params) => (
      <Chip
        label={params.row.WaiverStatus || "PENDING"}
        size="small"
        color={STATUS_COLORS[params.row.WaiverStatus] || "warning"}
        sx={{ fontWeight: 600, fontSize: "0.7rem" }}
      />
    ),
  },
];

const InterestWaiverTable = () => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const companyId = parseInt(decodedToken.CompanyId);

  const actions = {
    entity: localStorage.getItem("SelectedRight"),
    add: {
      key: "ADD",
      button_name: "New Interest Waiver",
      Show_Button: true,
      permission: "CreatePermission",
    },
    ApproveInterestWaiver: {
      key: "APPROVE",
      button_name: "Approve",
      Show_Button: true,
      permission: "ActivatePermission",
    },
    RejectInterestWaiver: {
      key: "REJECT",
      button_name: "Reject",
      Show_Button: true,
      permission: "ActivatePermission",
    },
    dataObject: {
      ignoreFields: [
        "CustomerId",
        "CompanyId",
        "ProductId",
        "IsPercentage",
        "PercentageValue",
        "MaxIncentive",
        "LoanBalanceBefore",
        "InterestAfter",
        "LoanBalanceAfter",
        "IsApproved",
        "IsCancelled",
        "CreatedBy",
        "ApprovedBy",
        "ApprovedAt",
        "Approver",
        "IdNoOrPassport",
        "FieldOfficerId",
        "FoUserName",
        "BranchName",
        "RegionName",
      ],
      objectName: "interestWaiversByColumnValues",
      parameters: { companyId, isApproved: 0, isCancelled: 0 },
      inputObjectName: "interestWaiver",
    },
    showStatus: true,
  };

  return (
    <Box m="20px">
      <DynamicTableForJson
        title="Interest Waiver"
        subtitle="Request interest waivers on customer loans and approve those pending review"
        FormComponent={InterestWaiverForm}
        columns={columns}
        base_url={base_url}
        actions={actions}
        tourSteps={rightsTourSteps}
      />
    </Box>
  );
};

export default InterestWaiverTable;
